import statistic from './statistic'

export default {
  settings: {
    hasOvertime: true,
    hasShootouts: true,
    hasDelayedEvents: true,
    hasGamerCondition: true
  },
  actionTypes: {
    numberOfPlayersChangeEvents: [
      '2_MIN_PENALTY',
      '2_AND_2_MIN_PENALTY',
      '5_MIN_PENALTY',
      '5_AND_2_MIN_PENALTY',
      'PLAYER_ON_PITCH',
      'START_OVERTIME_PERIOD',
      'ADJUST_TEAMS',
      'TEAM_CORRECTION',
      'READY_TO_START'
    ]
  },
  modules: {
    info: [
      'timer',
      {
        type: 'players',
        props: {
          home: ingameData => ingameData.playersCount.home,
          away: ingameData => ingameData.playersCount.away
        }
      },
      {
        type: 'periods',
        props: {
          className: 'liveCardPeriods__slider_left'
        }
      }
    ],
    score: {
      component: 'score-component',
      score: ingameData => ingameData.score
    },
    fieldScheme: {
      component: 'hockey-field'
    },
    statistic,
    eventLog: true
  },
  storeScheme: {
    gamerCondition: {
      home: {
        eventCode: '',
        title: '...'
      },
      away: {
        eventCode: '',
        title: '...'
      }
    },
    score: {
      home: 0,
      away: 0
    },
    playersCount: {
      home: 5,
      away: 5
    },
    shootoutsLog: {
      home: [],
      away: []
    },
    leftSideTeam: 1,
    getOvertimePeriodName: 'OT',
    shootoutPeriodName: 'SO',
    shootoutStatisticTitle: 'trader.penalty.shootout.score.bullets'
  }
}
